import {
  DecisionReason,
  HackleEvent,
  HackleUser,
  InAppMessage,
  InAppMessageContextMessage,
  Long,
  Properties
} from "../../../core/internal/model/model"
import { InAppMessageDeliverRequest } from "../deliver/InAppMessageDeliverRequest"
import { InAppMessageEligibilityEvaluation } from "../../../core/internal/evaluation/evalautor/iam/eligibility/InAppMessageEligibilityEvaluation"
import { InAppMessageLayoutEvaluation } from "../../../core/internal/evaluation/evalautor/iam/layout/InAppMessageLayoutEvaluation"

export class InAppMessagePresentRequest {
  constructor(
    public readonly dispatchId: String,
    public readonly inAppMessage: InAppMessage,
    public readonly message: InAppMessageContextMessage,
    public readonly user: HackleUser,
    public readonly requestedAt: Long,
    public readonly reason: DecisionReason,
    public readonly properties: Properties,
    public readonly triggerEvent: HackleEvent
  ) {}

  /**
   * @override
   */
  toString() {
    return `InAppMessagePresentRequest(dispatchId=${this.dispatchId}, inAppMessage=${this.inAppMessage}, user=${this.user.identifiers}, requestedAt=${this.requestedAt}, reason=${this.reason}, properties=${this.properties}, triggerEvent=${this.triggerEvent.key})`
  }

  static of(
    request: InAppMessageDeliverRequest,
    inAppMessage: InAppMessage,
    user: HackleUser,
    eligibilityEvaluation: InAppMessageEligibilityEvaluation,
    layoutEvaluation: InAppMessageLayoutEvaluation
  ): InAppMessagePresentRequest {
    return new InAppMessagePresentRequest(
      request.dispatchId,
      inAppMessage,
      layoutEvaluation.message,
      user,
      request.requestedAt,
      eligibilityEvaluation.reason,
      { ...request.properties, ...layoutEvaluation.properties },
      request.triggerEvent
    )
  }
}
